import type { FunctionComponent, ReactNode } from 'react';

import { useBoardId, useWorkspaceId } from '@trello/id-context';

import {
  PossiblyRenderAboutThisBoardModal,
  useAboutThisBoardModal,
} from 'app/src/components/AboutThisBoardModal';
import {
  LazyConfirmEmailModal,
  useConfirmEmailModal,
} from 'app/src/components/ConfirmEmailModal';
import {
  LazyReadOnlyBoardModal,
  useReadOnlyBoardModal,
} from 'app/src/components/ReadOnlyBoardModal';
import { ConditionalBoardOverlay } from './ConditionalBoardOverlay';

export const BoardOverlays: FunctionComponent = () => {
  const boardId = useBoardId();
  const workspaceId = useWorkspaceId();

  const { wouldRender: wouldRenderConfirmEmailModal } = useConfirmEmailModal({
    boardId,
  });

  const { wouldRender: wouldRenderReadOnlyBoardModal } = useReadOnlyBoardModal({
    boardId,
    workspaceId,
  });

  const { wouldRender: wouldRenderAboutThisBoardModal } =
    useAboutThisBoardModal({ boardId });

  let overlay: ReactNode;

  if (wouldRenderReadOnlyBoardModal) {
    overlay = <LazyReadOnlyBoardModal />;
  } else if (wouldRenderConfirmEmailModal) {
    overlay = <LazyConfirmEmailModal boardId={boardId} />;
  } else if (wouldRenderAboutThisBoardModal) {
    overlay = <PossiblyRenderAboutThisBoardModal boardId={boardId} />;
  }

  return (
    <>
      {overlay}
      <ConditionalBoardOverlay />
    </>
  );
};
